module.exports = __webpack_public_path__ + "static/media/pause.d1adec40.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pause.svg
// module id = 33
// module chunks = 0